import { Component , OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpUtils } from 'common';

@Component({
    selector: 'underlay-app-embed',
    template: require('./underlay-app-embed.html'),
    styles: [require('./underlay-app-embed.scss')]
})

export default class UnderlayEmbed implements OnInit {
    
    public iframeUrl;
    constructor(private sanitizer: DomSanitizer) { 
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/underlay-ui/index.html`);
    }

    public ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/components/underlay-app/underlay-app-embed.ts